// ==================================================
// Area 24 js methods
//
// Copyright 2024 Doctor Shop Srl
//
// ==================================================


function LoginBiologo(e) {
    try {
        e.preventDefault();
        waitingBS.Show();
        var formData = new FormData($('#floginBiologo')[0]);
        mainController.CallServiceFormDataAsync($('#floginBiologo').attr('action'), formData)
            .then(function (r) {
                if (r.esito == Costanti.ESITO_OK) {
                    window.location.href = r.ReturnUrl;
                }
                else {
                    waitingBS.Hide();
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage(r.responseText, r.NotifyColor);
            });
    } catch (err) {
        console.log(err);
    }
}

function ResetPasswordBiologo(e) {
    try {
        e.preventDefault();
        waitingBS.Show();
        var formData = new FormData($('#fResetPassword')[0]);
        mainController.CallServiceFormDataAsync($('#fResetPassword').attr('action'), formData)
            .then(function (r) {
                if (r.esito == Costanti.ESITO_OK) {
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                    setTimeout(function () {
                        window.location.href = r.ReturnUrl;
                    }, 3000);

                }
                else {
                    waitingBS.Hide();
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage(r.responseText, r.NotifyColor);
            });

    } catch (err) {
        console.log(err);
    }
}


function RichiediGiornata() {

    try {
        var esito = true;

        var ddlGiornata = $('#ddlTipoGiornata');
        if (!ddlGiornata.val()) {
            ddlGiornata.addClass('is-invalid');
            esito = false;
        }
        else {
            ddlGiornata.removeClass('is-invalid');
        }

        var Calendario = $('#dbGiornataRichiesta').dxDateBox('instance');
        if (!Calendario.option('value')) {
            Calendario.option('isValid', false);
            esito = false;
        }
        else {
            Calendario.option('isValid', true);
        }

        if (esito == true) {
            var params = {
                Data: Calendario.option('value'),
                TipoGiornata: $('#ddlTipoGiornata').val(),
                Note: $('#taNote').val()
            };
            $.ajax({
                url: $('#fAddGiornataFarmacia').attr('action'),
                type: 'POST',
                data: params,
                success: function (r) {
                    if (r) {
                        mainController.NotifyMessage(r.responseText, r.NotifyColor);
                        if (r.esito == Costanti.ESITO_OK) {
                            setTimeout(function () {
                                $('#gridGiornateRichieste').dxDataGrid('instance').refresh();
                            }, 25)
                            Calendario.option('value', null);
                            $('#ddlTipoGiornata').val('');
                            $('#taNote').val('');
                        }
                    }
                    else {
                        console.log('r is ' + typeof (r));
                    }
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(xhr);
                }
            });
        }
    }
    catch (error) {
        console.log(error);
    }

    return false;
}

function gridCalendario_OnCellPrepared(e, IdFarmacia) {

    var cell = $(e.cellElement);
    var cellValue = e.value;

    if (e.rowType !== 'header') {
        if (!cellValue) {
            cell.addClass('bg-secondary');
        }
        else if (cellValue) {
            //console.log(e);
            var isImpegnato = false;
            var tooltip = undefined;
            var giorniSettimana = ['Do', 'Lu', 'Ma', 'Me', 'Gio', 'Ve', 'Sa'];
            var data = new Date(cellValue.giornoSel);
            var numeroGiorno = data.getDay();
            var oggi = new Date();


            if (cellValue.IdUserFarmacia == IdFarmacia) {
                cell.attr('style', 'background-color: darkorange');
                tooltip = 'Giornata riservata, in attesa di definizione dei dettagli';
            }
            else if (cellValue.Impegnata == true) {
                tooltip = 'Giornata impegnata';
                if (cellValue.Appuntamenti && cellValue.Appuntamenti > 0) {
                    cell.addClass('bg-ds-color');
                    cell.addClass('text-dark');
                    tooltip += '\n Appuntamenti :' + cellValue.Appuntamenti;
                }
                else {
                    cell.attr('style', 'background-color: var(--bg-secondary)');
                }
                isImpegnato = true;
            }
            else if (cellValue.IsGiornoDisponibile == true ||
                ((cellValue.GiornoSettimana == giorniSettimana.indexOf(giorniSettimana.find(x => x == 'Sa'))) && isImpegnato == true && cellValue.IsGiornoDisponibile == true)) {
                cell.addClass('bg-success');
                cell.addClass('fw-bold');
                cell.addClass('text-white');
                tooltip = 'Giornata disponibile';
            }
            else if (cellValue.IsFestivo == true) {
                cell.addClass('bg-danger');
                cell.addClass('text-white');
                tooltip = 'Giornata festiva';
            }

            //if (isImpegnato == true) {
            //    if (cellValue.Farmacia) {
            //        tooltip += '\nFarmacia: ' + cellValue.Farmacia;
            //        tooltip += '\nCittà: ' + cellValue.FarmaciaCitta;
            //        tooltip += '\nIndirizzo: ' + cellValue.FarmaciaIndirizzo + ' (' + cellValue.FarmaciaProvincia + ')';
            //        tooltip += '\nCAP: ' + cellValue.FarmaciaCAP;
            //        if (cellValue.IDTipoGiornata) {
            //            tooltip += '\nTipo: ' + cellValue.TipoGiornata;
            //        }
            //    }
            //}

            if (data >= oggi) {
                if (isImpegnato == false && cellValue.IsFestivo == false) {
                    cell.addClass('cursor-pointer');
                    cell.attr('onclick', 'UpdateCalendarioBiologo(\'' + cellValue.giornoSel + '\',' + cellValue.IsGiornoDisponibile + ')');
                }
                else if (isImpegnato == true && cellValue.IsFestivo == false) {
                    cell.addClass('cursor-pointer');
                    cell.attr('onclick', 'ShowPopupGiornata(' + JSON.stringify(cellValue) + ')');
                }
            }
            else if (data < oggi) {
                cell.addClass('text-decoration-line-through');
            }

            cell.html(giorniSettimana[numeroGiorno]);
            cell.attr('title', tooltip);
        }
    }
}

function ShowPopupGiornata(e) {
    try {
        console.log(e);
        var data = new Date(e.giornoSel);
        //console.log(data);

        var popup = $('#popupGiornata').dxPopup('instance');

        if (popup) {

            popup.option('title', 'Dettagli giornata ' + formatDate(data))

            var template = '<div class="fw-bold fs-5 pb-2">Farmacia</div>';
            template += '<div><b>Ragione sociale</b>: ' + e.Farmacia + '</div>';
            template += '<div><b>Indirizzo</b>: ' + e.FarmaciaIndirizzo + ', ' + e.FarmaciaProvincia + '</div>';
            template += '<div><b>Citt&agrave;</b>: ' + e.FarmaciaCAP + ', ' + e.FarmaciaCitta + '</div>';

            if (e.IDTipoGiornata) {
                template += '<div class="fw-bold fs-5 pt-3 pb-2">Giornata</div>';
                template += '<div><b>Tipo</b>: ' + e.TipoGiornata + '</div>';
            }

            if (e.Appuntamenti && e.Appuntamenti > 0) {
                template += '<div class="fw-bold fs-5 pt-3 pb-2">Appuntamenti</div>';
                template += '<div><b>Quantit&agrave;</b>: ' + e.Appuntamenti + '</div>';
            }

            popup.option('contentTemplate', template);

            popup.show();
        }
    } catch (ex) {
        console.log(ex);
    }
}

function UpdateCalendarioBiologo(dataCella, isDisponibile) {
    try {
        var data = new Date(dataCella);

        var params = {
            giorno: data.getDate(),
            mese: data.getMonth() + 1,
            anno: data.getFullYear(),
            disponibile: isDisponibile
        };

        mainController.CallServiceAsync('/Akodoc/PutGiornataBiologo', params)
            .then(risp => {
                if (risp) {
                    if (risp.esito == Costanti.ESITO_OK) {
                        $('#gridCalendario').dxDataGrid('instance').refresh();
                        mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                    }
                    else {
                        mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });

    }
    catch (error) {
        console.log(error);
    }
}

function ScaricaPianoAlimentare(Password) {
    try {

        if (Password?.trim()) {
            var risp = "";
            var error = false;
            switch (Password.toUpperCase()) {

                case "DIETAIPER":
                    risp = "https://static.doctorshop.it/akodoc/dieta_iperproteica.pdf";
                    break;
                case "DIETAIPO":
                    risp = "https://static.doctorshop.it/akodoc/dieta_ipocalorica.pdf";
                    break;
                case "DIETANORMO":
                    risp = "https://static.doctorshop.it/akodoc/dieta_normocalorica.pdf";
                    break;
                default:
                    mainController.NotifyMessage("Password invalida", Costanti.NOTIFY_COLOR_ERROR);
                    error = true;
                    break;
            }
            if (error == false) {
                window.open(risp, "_blank");
            }
        }
        else {

            mainController.NotifyMessage("Password invalida", Costanti.NOTIFY_COLOR_ERROR);
        }
    }
    catch (error) {
        console.log(error);
    }
}